import { Button } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { PureComponent } from 'react';

import type { Country } from 'hocs/countries/api/types';
import type { WithPhoneSearchInjectedProps } from 'hocs/telephony';

import styles from './countrySelect.module.scss';
import FlagSelect, { ItemT } from './flagSelect';

type PropsT = {
  setShowTabs: (showTabs: boolean) => void;
  countries: Array<Country>;
  selectedCountry: Country | null;
  onSelect: (country: Country) => void;
} & WithPhoneSearchInjectedProps;

export default class CountrySelect extends PureComponent<PropsT> {
  @boundMethod
  onSelect(item: ItemT) {
    const { countries, onSelect } = this.props;
    const country = countries.find(
      ({ country_code }) => country_code === item.id,
    );

    if (!country) {
      return;
    }

    onSelect(country);
  }

  @boundMethod
  searchNumbers() {
    const {
      setShowTabs,
      selectedCountry: country,
      phoneSearch: { getItems },
    } = this.props;

    if (!country) {
      return;
    }

    getItems({ country }, ['national', 'geographic']);
    setShowTabs(true);
  }

  getCountryItems() {
    const { countries } = this.props;

    return countries.map(({ country, country_code, country_prefix }) => ({
      id: country_code,
      flag: country_code,
      name: `${country.toLowerCase()} (+${country_prefix})`,
    }));
  }

  renderPrefix() {
    const { selectedCountry } = this.props;
    const country = selectedCountry?.country_code?.toLowerCase();

    return (
      <div className={styles.selectPrefix}>
        <span className={classnames('flag', country)} />
      </div>
    );
  }

  render() {
    const { selectedCountry } = this.props;
    const selectedCountryCode = selectedCountry?.country_code;

    return (
      <div className={styles.root}>
        <div className={styles.rootSelect}>
          <label htmlFor="countryCode" className={styles.rootSelectLabel}>
            Country
          </label>
          <FlagSelect
            selectedItem={selectedCountryCode}
            items={this.getCountryItems()}
            onSelect={this.onSelect}
          />
        </div>
        <Button
          type="button"
          className={styles.rootSearch}
          onClick={this.searchNumbers}
        >
          Search
        </Button>
      </div>
    );
  }
}
